module.exports = __webpack_public_path__ + "assets/cff7f9d796f536de14e91fb962b21f51.png";